<script setup lang="ts">
import { toRefs } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useTenantStore } from '@/store';
import { EMIT } from '@/enum';

const tenantStore = useTenantStore();
const toast = useToast();

interface PropsInterface {
  id?: number;
  open: boolean;
}
const emit = defineEmits([EMIT.CANCEL, EMIT.UPDATE]);
const props = defineProps<PropsInterface>();
const { id, open } = toRefs(props);

const onCancel = () => emit(EMIT.CANCEL);

const onDelete = () => {
  if (id?.value) {
    tenantStore
      .deleteTenant(id.value)
      .then(() => {
        doSuccess('Tenant has been deactivated');
        emit(EMIT.UPDATE);
      })
      .catch(() => {
        doFail('Something went wrong. Please try again');
        emit(EMIT.CANCEL);
      });

    open.value = false;
  }
};

const doSuccess = (detail: string) => {
  toast.add({
    severity: 'success',
    summary: 'Tenant deactivated',
    detail: detail,
    life: 3000,
  });
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'error',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};
</script>

<template>
  <div>
    <ConfirmAction
      v-if="open"
      header="Deactivate Tenant"
      :message="`Are you sure you want to deactivate this tenant?`"
      accept-label="Deactivate"
      @accept="onDelete"
      @cancel="onCancel"
    >
      <div class="flex text-gray-800">
        <Icon name="warning" class="confirm-dialog-icon text-gray-600" />
        <span class="w-10 pl-3" v-text="`Are you sure you want to deactivate this tenant?`" />
      </div>
    </ConfirmAction>
  </div>
</template>
